import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectClustersType } from 'shared/map-search/selectors/clustersType';
import { TMapBounds } from 'shared/map-search/types/mapBounds';
import { IApplicationState } from 'shared/map-search/types/redux';

import { useFeaturesContext } from '../context';

interface IDetailsVisibilityManagerProps {
  onVisibilityChange(isVisible: boolean): void;
}

/**
 * @description
 * Менеджер для управления флагом отображения балуна с ценой у пина (детальные пины)
 */
export const DetailsVisibilityManager: React.FC<IDetailsVisibilityManagerProps> = ({ onVisibilityChange }) => {
  const { pointsLayer, hotspotsLayer, balloonManager, balloonPromoManager } = useFeaturesContext();
  const detailsVisiblePrecision = useSelector<IApplicationState, number>(state => state.detailsVisiblePrecision);
  const { precision } = useSelector<IApplicationState, TMapBounds>(state => state.mapBounds);
  const clustersType = useSelector(selectClustersType);

  const isDetailsVisibleByPrecision = precision >= detailsVisiblePrecision;

  React.useEffect(() => {
    pointsLayer.isDetailsVisible = isDetailsVisibleByPrecision;
    pointsLayer.pointType = clustersType;
    pointsLayer.layer.update();
    hotspotsLayer.isDetailsVisible = isDetailsVisibleByPrecision;
    hotspotsLayer.pointType = clustersType;
    hotspotsLayer.layer.update();
    balloonManager.pointType = clustersType;
    balloonPromoManager.pointType = clustersType;

    onVisibilityChange(isDetailsVisibleByPrecision);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isDetailsVisibleByPrecision, clustersType]);

  return null;
};
